import React from 'react';
import { defaultState, useModalManagerState } from './useModalManagerState';
/**
 * @typedef {import('./modalType').ModalType} ModalType
 */

/**
 * @typedef {import('./useModalManagerState').ModalMap} ModalMap
 */

/**
 * @typedef {import('./useModalManagerState').RegisterFn} RegisterFn
 */

/**
 * @typedef {Object} ModalManagerContextData
 * @property {ModalMap} modals
 * @property {RegisterFn | null} register
 * @property {(type: ModalType, id: string) => void} unregister
 * @property {(type: ModalType, id: string) => boolean} shouldRender
 */

/**
 * @type {ModalManagerContextData}
 */

const defaultContextValue = {
  modals: defaultState.modals,
  register: null,
  shouldRender: () => false,
  unregister: () => {}
};
export const ModalManagerContext = /*#__PURE__*/React.createContext(defaultContextValue);
export function ModalManagerProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    state,
    register,
    shouldRender,
    unregister
  } = useModalManagerState();
  return /*#__PURE__*/React.createElement(ModalManagerContext.Provider, {
    value: { ...state,
      register,
      shouldRender,
      unregister
    }
  }, children);
}